import { DropDown } from "./index";

export const JobTypeDropDown = (props) => {
  return <DropDown label="Type" name="contractType" options={options} {...props} />;
};

const options = ["full time", "freelance"];
